import * as React from 'react';

import { createIcon } from '../Icon';
export const CalendarIcon = createIcon(
  <React.Fragment>
    <rect height={18} rx={2} ry={2} width={18} x={3} y={4} />
    <line x1={16} x2={16} y1={2} y2={6} />
    <line x1={8} x2={8} y1={2} y2={6} />
    <line x1={3} x2={21} y1={10} y2={10} />
  </React.Fragment>,
  'CalendarIcon'
);
